import { Box } from "@chakra-ui/react";

import { useSelector } from "react-redux";
import { getReportDescription } from "../../store/helpers";
import ArrivalRatesPerHourReport from "../../components/branches/reports/ArrivalRatesPerHour";
import _ from "lodash";
import * as defaultSelectors from "../../store/selectors/defaultSelector";
import {
  ARRIVAL_RATES_SUMMARY_COLUMN_DEFINITIONS,
  getRenderConfigSummaryItems,
} from "../../store/renderConfig";

const ArrivalRatesPerHour = ({
  
  reportIndex = "**REPORT_INDEX**",
}) => {
  const reportRange = useSelector(defaultSelectors.selectReportRange);
  const reportsData = useSelector(defaultSelectors.selectReportsData);
  const renderConfig = useSelector(defaultSelectors.selectRenderConfig);
  let { data } = reportsData;
  
  const title = `${reportIndex}. Branch Arrival Rates Per Hour`;
  const presentationSummaryItems = getRenderConfigSummaryItems(renderConfig, {
    columnDefinitions: ARRIVAL_RATES_SUMMARY_COLUMN_DEFINITIONS,
  });

  //requires array of objects
  if (!_.isArray(data)) {
    data = [data];
  }

  return (
    <Box>
      <h1>{title}</h1>
      <p>{getReportDescription(reportRange).BranchesArrivalRatesPerHour}</p>
      {presentationSummaryItems.length ? (
        <div className="reportPresentationSummary">
          <strong>PRESENTATION</strong> {presentationSummaryItems.join(" / ")}
        </div>
      ) : null}
      {!_.isEmpty(data) ? (
        <>
          <ArrivalRatesPerHourReport
            reportIndex={reportIndex}
            data={data}
          />
        </>
      ) : (
        <Box mt={10}>
          <p>No data available in this report</p>
        </Box>
      )}
    </Box>
  );
};

export default ArrivalRatesPerHour;
